import { render, staticRenderFns } from "./ExternalLottery.vue?vue&type=template&id=7c215b58&"
import script from "./ExternalLottery.vue?vue&type=script&lang=ts&"
export * from "./ExternalLottery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports